import { carouselData } from '@/mocks/homeData';

const carouselImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=Warm%20crimson%20red%20and%20dark%20charcoal%20abstract%20art%20composition%2C%20dramatic%20spotlight%20effect%20on%20stage%20concept%2C%20entertainment%20industry%20awards%20ceremony%20atmosphere%2C%20sophisticated%20editorial%20magazine%20cover%20style%2C%20strong%20contrast%20and%20deep%20shadows%2C%20no%20people%20no%20text&width=1400&height=700&seq=carousel-1-911&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20archive%20room%20atmosphere%20with%20warm%20amber%20glow%2C%20old%20newspapers%20and%20case%20files%20concept%2C%20investigative%20journalism%20archival%20aesthetic%2C%20film%20noir%20lighting%20with%20dust%20motes%2C%20no%20people%20no%20text&width=1400&height=700&seq=carousel-2-911&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=Dark%20corporate%20behind%20the%20scenes%20atmosphere%20with%20warm%20red%20and%20gold%20lighting%2C%20power%20and%20money%20concept%20abstract%2C%20luxury%20and%20corruption%20contrast%2C%20cinematic%20noir%20photography%2C%20strong%20dramatic%20shadows%2C%20no%20people%20no%20text&width=1400&height=700&seq=carousel-3-911&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=Warm%20glowing%20magnifying%20glass%20over%20dark%20surface%20concept%2C%20detective%20investigation%20atmosphere%2C%20truth%20seeking%20abstract%20composition%2C%20crimson%20and%20dark%20amber%20color%20palette%2C%20editorial%20documentary%20style%2C%20no%20people%20no%20text&width=1400&height=700&seq=carousel-4-911&orientation=landscape',
};

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-[1300px]">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-accent-700 bg-accent-100 rounded-full mb-3">
            深度策划
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">焦点专题</h2>
          <p className="mt-2 text-sm text-foreground-600">资深编辑团队精心策划的深度内容</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {carouselData.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group relative rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer aspect-[16/9] md:aspect-[2/1]"
            >
              <img
                src={carouselImages[item.id]}
                alt={item.title}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/10"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 text-[10px] font-bold bg-accent-500 text-white rounded">
                    {item.tag}
                  </span>
                  <span className="text-[11px] text-white/70">{item.label}</span>
                </div>
                <h3 className="text-base md:text-lg font-bold text-white leading-snug mb-1.5 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-white/70 leading-relaxed line-clamp-2 max-w-xl">
                  {item.excerpt}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}